import React, {useEffect, useState} from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import {FaEdit, FaPlayCircle, FaTrash, FaVideo} from "react-icons/fa";

export default function Exercises() {
    const [exercises, setExercises] = useState([]);
    const [groups, setGroups] = useState([]);
    const [form, setForm] = useState({
        muscle_group_id: "",
        name: "",
        target_reps: "",
        description: "",
        video: null
    });
    const [videoPreview, setVideoPreview] = useState(null);
    const [editId, setEditId] = useState(null);
    const [confirmDeleteId, setConfirmDeleteId] = useState(null);
    const [errors, setErrors] = useState({});
    const [showVideo, setShowVideo] = useState(false);
    const [selectedVideoUrl, setSelectedVideoUrl] = useState(null);

    useEffect(() => {
        fetchExercises();
        fetchGroups();
    }, []);

    const fetchExercises = async () => {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/exercises`);
        setExercises(res.data);
    };

    const fetchGroups = async () => {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/muscle-groups`);
        setGroups(res.data);
    };

    const validateForm = () => {
        let newErrors = {};
        if (!form.muscle_group_id) newErrors.muscle_group_id = "المجموعة مطلوبة";
        if (!form.name.trim()) newErrors.name = "اسم التمرين مطلوب";
        if (!form.target_reps) newErrors.target_reps = "عدد الجولات مطلوب";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;

        const formData = new FormData();
        formData.append("muscle_group_id", form.muscle_group_id);
        formData.append("name", form.name);
        formData.append("target_reps", form.target_reps);
        formData.append("description", form.description);
        if (form.video) {
            formData.append("video", form.video);
        }

        if (editId) {
            await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/exercises/${editId}`, formData, {
                headers: {"Content-Type": "multipart/form-data"}
            });
        } else {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/exercises`, formData, {
                headers: {"Content-Type": "multipart/form-data"}
            });
        }

        setForm({muscle_group_id: "", name: "", target_reps: "", description: "", video: null});
        setVideoPreview(null);
        setEditId(null);
        setErrors({});
        fetchExercises();
    };

    const handleEdit = (exercise) => {
        setForm({
            muscle_group_id: exercise.muscle_group_id,
            name: exercise.name,
            target_reps: exercise.target_reps,
            description: exercise.description || "",
            video: null
        });
        setEditId(exercise.id);
        setVideoPreview(exercise.video_url ? `${process.env.REACT_APP_BACKEND_URL}${exercise.video_url}` : null);
        setErrors({});
    };

    const handleDelete = async () => {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/exercises/${confirmDeleteId}`);
        setConfirmDeleteId(null);
        fetchExercises();
    };

    const handleShowVideo = (videoUrl) => {
        if (!videoUrl) return;
        setSelectedVideoUrl(`${process.env.REACT_APP_BACKEND_URL}${videoUrl}`);
        setShowVideo(true);
    };


    return (
        <div className={"content"}>
            <div dir="rtl" className="container mt-4">
                <h2 className="text-center mb-4">التمارين</h2>

                {/* نموذج إضافة / تعديل */}
                <div className="card p-3 mb-4 shadow-sm">
                    <h4>{editId ? "تعديل تمرين" : "إضافة تمرين جديد"}</h4>

                    {/* Row 1: المجموعة + اسم التمرين */}
                    <div className="row mb-3">
                        <div className="col-md-6 col-sm-12">
                            <label className="form-label">المجموعة</label>
                            <select
                                className={`form-select ${errors.muscle_group_id ? "is-invalid" : ""}`}
                                value={form.muscle_group_id}
                                onChange={(e) => setForm({...form, muscle_group_id: e.target.value})}
                            >
                                <option value="">اختر المجموعة</option>
                                {groups.map((g) => (
                                    <option key={g.id} value={g.id}>{g.name}</option>
                                ))}
                            </select>
                            {errors.muscle_group_id && <div className="invalid-feedback">{errors.muscle_group_id}</div>}
                        </div>

                        <div className="col-md-6 col-sm-12">
                            <label className="form-label">اسم التمرين</label>
                            <input
                                type="text"
                                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                value={form.name}
                                onChange={(e) => setForm({...form, name: e.target.value})}
                            />
                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                        </div>
                    </div>

                    {/* Row 2: عدد الجولات + الوصف */}
                    <div className="row mb-3">
                        <div className="col-md-6 col-sm-12">
                            <label className="form-label">عدد الجولات المطلوبة</label>
                            <input
                                type="number"
                                className={`form-control ${errors.target_reps ? "is-invalid" : ""}`}
                                value={form.target_reps}
                                onChange={(e) => setForm({...form, target_reps: e.target.value})}
                            />
                            {errors.target_reps && <div className="invalid-feedback">{errors.target_reps}</div>}
                        </div>

                        <div className="col-md-6 col-sm-12">
                            <label className="form-label">الوصف (اختياري)</label>
                            <textarea
                                className="form-control"
                                rows="1"
                                value={form.description}
                                onChange={(e) => setForm({...form, description: e.target.value})}
                            ></textarea>
                        </div>
                    </div>


                    {/* Row 3: رفع الفيديو */}
                    <div className="row mb-3">
                        <div className="col-md-6 col-sm-12">
                            <label className="form-label">فيديو التمرين (اختياري)</label>
                            <input
                                type="file"
                                accept="video/*"
                                className="form-control"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    setForm({...form, video: file});
                                    setVideoPreview(URL.createObjectURL(file));
                                }}
                            />
                        </div>

                    </div>

                    {/* Row 3: أزرار الحفظ والإلغاء */}
                    <div className="row">
                        <div className="col-12 d-flex justify-content-start">
                            <button className="btn btn-success me-2" onClick={handleSubmit}>
                                {editId ? "تحديث" : "إضافة"}
                            </button>
                            {editId && (
                                <button
                                    className="btn btn-secondary me-3"
                                    onClick={() => {
                                        setEditId(null);
                                        setForm({muscle_group_id: "", name: "", target_reps: "", description: ""});
                                    }}
                                >
                                    إلغاء
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* جدول التمارين */}
                <table className="table table-bordered table-striped shadow-sm"
                       style={{minHeight: "650px", overflowY: "auto"}}>
                    <thead className="table-light">
                    <tr>
                        <th>#</th>
                        <th>التمرين</th>
                        <th>المجموعة</th>
                        <th>الجولات المطلوبة</th>
                        <th>الوصف</th>
                        <th>الإجراءات</th>
                    </tr>
                    </thead>
                    <tbody>
                    {exercises.map((ex, i) => (
                        <tr key={ex.id}>
                            <td>{i + 1}</td>
                            <td>{ex.name}</td>
                            <td>{ex.muscle_group_name}</td>
                            <td>{ex.target_reps}</td>
                            <td>{ex.description}</td>
                            <td>

                                <FaEdit
                                    style={{cursor: "pointer", color: "blue", marginRight: "10px"}}
                                    size={18}
                                    title="تعديل"
                                    onClick={() => handleEdit(ex)}
                                />
                                <FaTrash
                                    style={{cursor: "pointer", color: "red", marginRight: "10px"}}
                                    size={18}
                                    title="حذف"
                                    onClick={() => setConfirmDeleteId(ex.id)}
                                />
                                {ex.video_url && (
                                    <FaPlayCircle
                                        style={{cursor: "pointer", color: "#0d6efd", marginRight: "10px"}}
                                        size={22}
                                        title="عرض الفيديو"
                                        onClick={() => handleShowVideo(ex.video_url)}
                                    />
                                )}

                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                {showVideo && (
                    <div className="modal d-block" tabIndex="-1" style={{backgroundColor: "rgba(0,0,0,0.7)"}}>
                        <div className="modal-dialog modal-dialog-centered modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">عرض الفيديو</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowVideo(false)}></button>
                                </div>
                                <div className="modal-body text-center">
                                    <video width="100%" height="auto" controls>
                                        <source src={selectedVideoUrl} type="video/mp4"/>
                                        متصفحك لا يدعم تشغيل الفيديو
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* تأكيد الحذف */}
                {confirmDeleteId && (
                    <div className="modal d-block" tabIndex="-1" style={{backgroundColor: "rgba(0,0,0,0.5)"}}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">تأكيد الحذف</h5>
                                </div>
                                <div className="modal-body">
                                    <p>هل أنت متأكد أنك تريد حذف هذا التمرين؟</p>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-danger" onClick={handleDelete}>نعم، حذف</button>
                                    <button className="btn btn-secondary"
                                            onClick={() => setConfirmDeleteId(null)}>إلغاء
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
